// extracted by mini-css-extract-plugin
export var imageFrame = "parallaxContainer-module--image-frame--ABHe6";
export var imageFrame__inner = "parallaxContainer-module--image-frame__inner--XXsx-";
export var imageWrapper = "parallaxContainer-module--image-wrapper--CRfaf";
export var image = "parallaxContainer-module--image--bDkPo";